import type { AssignedAssignmentsFilters } from '@repo/types/assignments';

import { useInfiniteQuery } from '@tanstack/react-query';

import { AssignmentService } from './assignmentService';
import { AssignmentKey } from './keys';

interface UseGetAssignedAssignmentsInfiniteProps {
  name?: string;
  filter?: AssignedAssignmentsFilters;
  groupId?: number;
  enabled?: boolean;
}

export function useGetAssignedAssignmentsInfinite(props: UseGetAssignedAssignmentsInfiniteProps) {
  const { name, filter, groupId, enabled = true } = props;
  return useInfiniteQuery({
    queryKey: [AssignmentKey.ASSIGNED_ASSIGNMENTS_INFINITE, name, filter, groupId],
    enabled,
    queryFn: ({ pageParam }) =>
      AssignmentService.getAssignedAssignments({
        ...pageParam,
        name,
        filter,
        groupId,
      }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) return undefined;
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
